<template>
    <div class="py-3">
        <draggable
            :value="value"
            :disabled="disabled"
            ghost-class="opacity-50"
            handle=".handle"
            @choose="froalaStore.disableFroala = true"
            @input="data => $emit('input', data)"
            @unchoose="froalaStore.disableFroala = false"
        >
            <div v-for="(row, index) in value" :key="`table-row-${index}-${generateKey()}`" class="grid grid-cols-16 relative">
                <div class="col-span-1 handle pr-1 text-gray-400 dark:text-gray-200 hover:text-gray-600 dark:hover:text-gray-400 cursor-pointer transition duration-150 transform mt-4"
                      title="Drag to reorder items">
                    <svg v-if="value.length > 1" class="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"
                         xmlns="http://www.w3.org/2000/svg">
                        <path d="M16 17l-4 4m0 0l-4-4m4 4V3" stroke-linecap="round" stroke-linejoin="round"
                              stroke-width="2"/>
                        <path d="M8 7l4-4m0 0l4 4m-4-4v18" stroke-linecap="round" stroke-linejoin="round"
                              stroke-width="2"/>
                    </svg>
                    <span v-if="debugStore.debugMode && row.id" class="font-mono">
                        [TableRow:{{ row.id }}]
                    </span>
                </div>
                <table-row
                    v-model="value[index]"
                    :type-id="typeId"
                    :language="language"
                    :document-type="documentType"
                    :disabled="disabled"
                    class="col-span-15"
                    @reference-label-changed="(data) => $emit('reference-label-changed', {...data, tr: index})"
                    @cell-type-changed="(data) => $emit('cell-type-changed', {...data, tr: index})"
                    :error="error && error[index] ? error[index] : null"
                />
                <button
                    :disabled="disabled"
                    class="absolute -right-8 top-1/2 transform -translate-y-1/2 hover:bg-red-500 hover:text-red-100 transition duration-75 bg-red-600 text-white rounded shadow justify-center flex items-center"
                    type="button"
                    @click="deleteRow(index)"
                >
                    <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"
                         xmlns="http://www.w3.org/2000/svg">
                        <path d="M6 18L18 6M6 6l12 12" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                    </svg>
                </button>
            </div>
        </draggable>
    </div>
</template>

<script>
import draggable from 'vuedraggable';
import siteLanguage from '../../config/siteLanguage'
import {v4 as uuidv4} from 'uuid';
import {useFroalaStore} from "../../stores/froala";
import {useDebugStore} from "../../stores/debug";

export default {
    name: "TableBody",
    components: {
        draggable,
    },
    props: {
        value: {
            type: Array,
            required: true,
        },
        language: {
            type: Object,
            default: () => {
                return {
                    iso: siteLanguage.iso.ENGLISH,
                    id: siteLanguage.language.ENGLISH,
                };
            },
        },
        typeId: {
            type: Number,
            required: true,
        },
        documentType: {
            type: String,
            required: false,
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        error: {
            type: Array,
            required: false,
        },
    },
    data() {
        return {
            froalaStore: useFroalaStore(),
            debugStore: useDebugStore(),
        };
    },
    methods: {
        generateKey() {
            return uuidv4();
        },
        deleteRow(index) {
            this.value.splice(index, 1);
        },
    },
}
</script>
